import { render } from "./SurveyingScene.vue?vue&type=template&id=0c0fc8f0&scoped=true"
import script from "./SurveyingScene.vue?vue&type=script&lang=js"
export * from "./SurveyingScene.vue?vue&type=script&lang=js"

import "./SurveyingScene.vue?vue&type=style&index=0&id=0c0fc8f0&scoped=true&lang=css"

import exportComponent from "/Users/zellwegv/repos-work/ce-365-spiral-curve/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0fc8f0"]])

export default __exports__